import Walls from './House/Walls'
import Roof from './House/Roof'
import Kitchen from './House/Kitchen'
import Bedroom from './House/Bedroom'
import Livingroom from './House/Livingroom'
import Lunchroom from './House/Lunchroom'
import Bathroom from './House/Bathroom'
import Floor from './House/Floor'
import MyWindows from './House/MyWindows'
import VinylsCovers from './House/VinylsCovers'
import Mug from './House/Mug'
import Soap from './House/Soap'
import ShaderTab from './House/ShaderTab'
import ShaderParticles from './House/ShaderParticles'
import ShaderSmoke from './House/ShaderSmoke'
import { Text } from '@react-three/drei'
import { DoubleSide } from 'three'

export default function House(props) {

  return (
    <group {...props} dispose={null}>     

      <Walls nodes={ props.nodes }/>
      <Roof nodes= { props.nodes} />
      <Kitchen nodes={ props.nodes } />
      <Bedroom nodes={ props.nodes } />
      <Livingroom nodes= { props.nodes } />
      <Lunchroom nodes= { props.nodes } />
      <Bathroom nodes= { props.nodes } />
      <Floor nodes= { props.nodes } />
      <MyWindows nodes= { props.nodes } />
      <VinylsCovers nodes= { props.nodes } />
      <Mug nodes= { props.nodes } />
      <Soap nodes= { props.nodes } />
      <ShaderTab/> 
      <ShaderParticles />
      <ShaderSmoke/>

      {/* House sign overlay — covers original "Maxime House" lettering */}
      <Text
        font="./fonts/Bangers.ttf"
        position={[1.1, 4.0, -4.15]}
        rotation={[0, Math.PI, 0]}
        fontSize={0.5}
        color="#7a9e7e"
        maxWidth={2.0}
        textAlign="center"
        material-side={DoubleSide}
        letterSpacing={0.04}
        lineHeight={1.1}
        renderOrder={1}
      >
        {"GOPI'S\nHOUSE"}
      </Text>

   
    </group>
  )
}
